import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const useScrollTopHook = () => {
  const { pathname } = useLocation()
  const rootElement = document.getElementById('root') as HTMLElement
  const pagelayoutElement = document.getElementById('pagelayout') as HTMLElement

  useEffect(() => {
    if (rootElement && pagelayoutElement) {
      pagelayoutElement.style.height = 'unset'
      rootElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
      pagelayoutElement.style.height = `calc(var(--vh, 1vh) * 100)`
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])
}

export default useScrollTopHook
